export const COMPREHENSION_LESSON_TYPE = 'COMPREHENSION'
export const FLUENCY_LESSON_TYPE = 'FLUENCY'
export const K_ONE_LESSON_TYPE = 'K_ONE'
